import React, { useState, useEffect } from 'react'
import './UploadInput.scss';

import clip from '../../../../assets/images/adjuntar.png'

export const UploadInput = ({value, onChange, error}) => {
  const [previewImg, setPreviewImg] = useState('');

  useEffect(() => {
    setPreviewImg(value)
  }, [value])

  const onChangeFile = (e) => {
    if(e.target.files.length){
      const file = e.target.files[0];
      if(!file.type.includes('image')) return;
      const src = window.URL.createObjectURL(file);
      // setPreviewImg(src);
      onChange(src);
    }
  }
  return (
    <div className='upload-input'>
      <div className={`image-preview ${error && 'error-input'}`}>
        { previewImg && <img src={previewImg} alt='preview-img'/>}
      </div>
      <div className='input-file-container'>
        <input
          type='file'
          className='input-file'
          onChange={onChangeFile}
          // value={value}
        />
        <label><img src={clip} alt='clip'/> Imagen</label>
      </div>
    </div>
  )
}

export default UploadInput
